import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

const addSigner = createAsyncThunk(
  "documentShow/addSigner",
  async (addSignerData :any, { getState, rejectWithValue }) => {
    const {idUser} = addSignerData
    const {idDoc} = addSignerData
    try {
      const state = getState() as RootState;

      let order = 1;
      
      const url = new URL(`${api.baseURL}documentstakeholder`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        body: JSON.stringify({
          document: idDoc,
          stakeholder: idUser,
          type: "Firmante",
          order,
        }),
        method: "POST",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default addSigner;
